<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    // let appid = "wxf29821b8ccd0a697"
    let appid = 'wx8f893adb1c19030a'  //线上

    var wxsvcbase = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +appid + "&redirect_uri="



    // let redirectUrl = encodeURIComponent("https://test.hkaspire.net/wechat/public/wxuser/get/info/" + appid + "/" + this.$route.query.invite + "/" + this.$route.query.agentname + "/" + this.$route.query.phone+ "/" 
    // + this.$route.query.oid+ "/"+this.$route.query.oname+ "/" + this.$route.query.ophone )

    let redirectUrl = encodeURIComponent("https://app.hkaspire.cn/wechat/public/wxuser/get/info/" + appid + "/" + this.$route.query.invite + "/" + this.$route.query.agentname + "/" + this.$route.query.phone+ "/" 
    + this.$route.query.oid+ "/"+this.$route.query.oname+ "/" + this.$route.query.ophone)   //线上
    

    // let url = encodeURIComponent(`http://192.168.200.182:8080/#/?j=j`)
    let url = encodeURIComponent(`https://emoj.caredaily.com/#/?j=j`)  //线上

    window.location = wxsvcbase + redirectUrl +"&response_type=code&scope=snsapi_userinfo&state=" + url +"#wechat_redirect"
  }
};
</script>

<style scoped>
</style>